module.exports = __webpack_public_path__ + "img/sdg13_id.df447e32.svg";